import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { NakedUl } from '../../../../naked/naked-ul.component';
import type { ListboxChildren } from '../../../listbox/listbox.provider';
import { Text } from '../../../text/text.component';

export type OptionGroupProps = {
  children: ListboxChildren;
  label: string;
};

const groupListStyle = css`
  li {
    padding: ${theme.spacing(1, 2, 1, 4)};
  }
`;

const groupLabelStyle = css`
  margin: ${theme.spacing(1, 0.5, 0.5, 2)};
`;

export const OptionGroup = ({ children, label }: OptionGroupProps) => {
  return (
    <li>
      <NakedUl className={groupListStyle}>
        <Text size='large' weight='bold' className={groupLabelStyle}>
          {label}
        </Text>
        {children}
      </NakedUl>
    </li>
  );
};
